import { MaxManutation } from "./manutation";

export function MaxSettings() {
  return (<div>
    <MaxManutation />
  </div>);
}
